import jsonExport from 'jsonexport/dist/index.js';
import { downloadCSV } from "./downloadCSV.js";
export var defaultExporter = function (data, _, __, resource) {
    return jsonExport(data, function (err, csv) { return downloadCSV(csv, resource); });
};
//# sourceMappingURL=defaultExporter.js.map